import { render, staticRenderFns } from "./PhotoShow.vue?vue&type=template&id=1a4909d6"
import script from "./PhotoShow.vue?vue&type=script&lang=js"
export * from "./PhotoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports